export const churnkeyMode = process.env.REACT_APP_CHURNKEY_MODE || 'live';
export const isTestingEnvironment =
  process.env.REACT_APP_TESTING_ENVIRONMENT === 'true' || false;

export const stripePublishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  'pk_live_51MWobYLVMiFmGBXgP9w4HKOk35j7cDD15wiaWzIkSzoItZrVid2tzycWkOyr7VBv3VLYBKSQx2sVVAVNorRoQAfU00ZFgCQ6ke';
